import { Card as MuiCard } from '@material-ui/core';

export default function Card({ children }) {
  return <MuiCard variant='outlined'>{children}</MuiCard>;
}
